import {ReactSession} from "../utils/ReactSession.jsx";
import {AES, enc} from "crypto-js";
import Header from "./Header.jsx";
import {Suspense, useEffect, useState, useRef} from "react";
import ApiRequester from "./ApiRequester.jsx";
import Button from "./component-assets/Button.jsx";
import Footer from "./Footer.jsx";
import CampusDropDown from "./component-assets/CampusDropDown.jsx";
import {
    actionAppearance,
    arraysEqual, bulkDeleteModal, checkAll, formCheck,
    formFail,
    formSuccess,
    handleSubmitActions, iAmHigherAuthority,
    isBannerPresent, rangeSliderHandler, reloadSessionCampusItems, searchFunc, showModal,
    sortFunc
} from "../libs.jsx";
import TableBody from "./component-assets/TableBody.jsx";
import {ToastContainer} from "react-toastify";
import TableHeaders from "./component-assets/TableHeaders.jsx";
import BulkDeleteModal from "./component-assets/BulkDeleteModal.jsx";
import Navigation from "./Navigation.jsx";

const SystemSettings = (props) => {

    let dData, reasonHeaderData, preformHeaderData;

    reasonHeaderData = [
        {label: "Reason", key: "reason_code_description", align: "center"},
        {label: "Reason Category", key: "pal_reason_description", align: "center"}
    ];

    preformHeaderData = [
        {label: "Note Template", key: "preform_note", align: "center", filtered: false},
        {label: "Initially Added", key: "create_time", align: "center", type: "datetime-utc", filtered: false},
        {label: "Last Updated", key: "last_modified", align: "center", type: "datetime-utc", filtered: false},
        {label: "Last Updated By", key: "display_name", align: "center", filtered: false,
            link: {enabled: true, linkto: "/profiles/user", linkkey: "modified_by"}}
    ];

    if (ReactSession.get("PAL") != null) {
        let bData = AES.decrypt(ReactSession.get("PAL"), import.meta.env.VITE_ESECRET);
        dData = JSON.parse(bData.toString(enc.Utf8));
    }

    // Page Control
    const [tabItem, setTabItem] = useState("init");
    const [loaded, setLoaded] = useState(false);
    const [campusId, setCampusId] = useState(dData.acnt);
    const [count, setCount] = useState(1);
    const [outputOp, setOutputOp] = useState("");

    // Alert Behavior Section
    const [configData, setConfigData] = useState([]);
    const [configLoaded, setConfigLoaded] = useState(false);
    const [alertTTL, setAlertTTL] = useState(0);
    const [afrAccept, setAFRAccept] = useState(false);
    const [afrFinish, setAFRFinish] = useState(false);
    const [afrReason, setAFRReason] = useState(false);
    const [rTimeout, setRTimeout] = useState(0);
    const [fTimeout, setFTimeout] = useState(0);
    const [cTimeout, setCTimeout] = useState(0);
    const [alertListOrigin, setAlertListOrigin] = useState([]);
    const [alertList, setAlertList] = useState([]);
    const [alertSettingId, setAlertSettingId] = useState(0);

    // Custom User Section
    const [customData, setCustomData] = useState([]);
    const [customLoaded, setCustomLoaded] = useState(false);
    const [customList, setCustomList] = useState([]);
    const [customOriginList, setCustomOriginList] = useState([]);
    const [displayItem, setDisplayItem] = useState(false);
    const [groupItem, setGroupItem] = useState(false);

    // High Priority Event Section
    const [priorityData, setPriorityData] = useState([]);
    const [priorityLoaded, setPriorityLoaded] = useState(false);
    const [priorityOriginList, setPriorityOriginList] = useState([]);
    const [priorityList, setPriorityList] = useState([]);
    const [priorityListLoaded, setPriorityListLoaded] = useState(false);
    const [eventTypeData, setEventTypeData] = useState([]);
    const [eventTypesLoaded, setEventTypesLoaded] = useState(false);
    const [prioritySetList, setPrioritySetList] = useState([]);

    // AFR Device Section
    const [afrData, setAFRData] = useState([]);
    const [afrOriginList, setAFROriginList] = useState([]);
    const [afrList, setAFRList] = useState([]);
    const [afrLoaded, setAFRLoaded] = useState(false);
    const [afrListLoaded, setAFRListLoaded] = useState(false);
    const [devTypesData, setDevTypesData] = useState([]);
    const [typesLoaded, setTypesLoaded] = useState(false);
    const [afrSetList, setAFRSetList] = useState([]);

    // Custom Reason Section
    const [reasonData, setReasonData] = useState([]);
    const [globalReasons, setGlobalReasons] = useState([]);
    const [globalOptions, setGlobalOptions] = useState([]);
    const [reasonRows, setReasonRows] = useState([]);
    const [reasonLoaded, setReasonLoaded] = useState(false);
    const [globalReasonsLoaded, setGlobalReasonsLoaded] = useState(false);
    const [reasonIdList, setReasonIdList] = useState([]);
    const [reasonStoredIndex, setReasonStoredIndex] = useState(0);
    const [reasonDContent, setReasonDContent] = useState("");
    const [reasonSorter, setReasonSorter] = useState({
        sortColumn: "cloud_reason_code_id",
        sortOrder: "desc"
    })

    // Server Section
    const [emailTags, setEmailTags] = useState([]);
    const [initialEmailTags, setInitialEmailTags] = useState([]);
    const [emailError, setEmailError] = useState("");
    const [isEmailValid, setIsEmailValid] = useState(true);
    const [phoneTags, setPhoneTags] = useState([]);
    const [initialPhoneTags, setInitialPhoneTags] = useState([]);
    const [phoneError, setPhoneError] = useState("");
    const [isPhoneValid, setIsPhoneValid] = useState(true);
    const [sysOfflineTime, setSysOfflineTime] = useState(null);
    const [initSysOfflineTime, setInitSysOfflineTime] = useState(null);
    const emailInputRef = useRef(null);
    const phoneInputRef = useRef(null);

    // Preform Notes Section
    const [preformOriginData, setPreformOriginData] = useState([]);
    const [preformActiveData, setPreformActiveData] = useState([]);
    const [preformTableRows, setPreformTableRows] = useState([]);
    const [preformLoaded, setPreformLoaded] = useState(false);
    const [preformIdList, setPreformIdList] = useState([]);
    const [preformDContent, setPreformDContent] = useState("");
    const [preformStoredIndex, setPreformStoredIndex] = useState([]);
    const [preformSearch, setPreformSearch] = useState("");
    const [campusCopyOptions, setCampusCopyOptions] = useState([]);
    const [campusList, setCampusList] = useState(dData.acntList);
    const [campusData, setCampusData] = useState(dData.campusData);
    const [preformSorter, setPreformSorter] = useState({
        sortColumn: "preform_note",
        sortOrder: "asc"
    });

    useEffect(() => {
        let interval = null;
        interval = setInterval(() => {
             setCount(count => count - 1);
        }, 1000);
        if (count <= 0) {
            // Alert Settings Data
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: campusId,
                                Tbl: "core_campus_alert_settings",
                                procedure: "fetchbyparameter", reqType: "direct"}).then(data => {
                setConfigData(data ? data : []);
                setConfigLoaded(true);
            });
            // AFR Settings DATA
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: campusId,
                                payload: {campus_id: campusId},
                                procedure: "getAFRDevices", reqType: "stored"}).then(data => {
                setAFRData(data ? data : []);
                setAFRLoaded(true);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: campusId,
                                payload: {campus_id: campusId},
                                procedure: "getAllDeviceTypes", reqType: "stored"}).then(data => {
                setDevTypesData(data ? data : []);
                setTypesLoaded(true);
            });
            // Reason Code Settings Data
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: campusId,
                                payload: {campus_id: campusId},
                                procedure: "getReasonCodes", reqType: "stored"}).then(data => {
                setReasonData(data ? data : []);
                setReasonLoaded(true);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: campusId,
                                Tbl: "att_palcare_reasoncode", procedure: "fetchall",
                                reqType: "direct"}).then(data => {
                setGlobalReasons(data ? data : []);
                setGlobalReasonsLoaded(true);
            });
            // Custom User Settings
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: campusId, Tbl: "core_campus",
                                procedure: "fetchbyparameter", reqType: "direct"}).then(data => {
                setCustomData(data ? data : []);
                setCustomLoaded(true);
            });
            // High Priority Data
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: campusId, Tbl: "core_high_priority_entity",
                                procedure: "fetchbyparameter", reqType: "direct"}).then(data => {
                setPriorityData(data ? data : []);
                setPriorityLoaded(true);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: campusId, Tbl: "att_event_types",
                                procedure: "fetchall", reqType: "direct"}).then(data => {
                setEventTypeData(data ? data : []);
                setEventTypesLoaded(true);
            });
            if (dData?.event_notes_active && dData?.event_notes_preform){
                ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: campusId,
                                    procedure: "getpreformnotes", reqType: "stored"}).then(data => {
                    setPreformOriginData(data ? data : []);
                    setPreformLoaded(true);
                });
            }
            setCount(count => 600);
        }
        return () => clearInterval(interval);
    }, [count]);

    useEffect(() => {
        if (![reasonLoaded, typesLoaded, afrLoaded, configLoaded, customLoaded, globalReasonsLoaded,
              priorityLoaded, eventTypesLoaded, preformLoaded].includes(false)){
            setLoaded(true);
            setTabItem("alert");
        }
    }, [reasonLoaded, typesLoaded, afrLoaded, configLoaded, customLoaded, globalReasonsLoaded,
             priorityLoaded, eventTypesLoaded, preformLoaded]);

    useEffect(() => {
        let dItem, gItem, emails, phones, offTime;
        if (customLoaded && customData && customData.length > 0){
            dItem = customData[0]?.is_name_editable === 1;
            gItem = customData[0]?.is_group_editable === 1;
            setDisplayItem(dItem);
            setGroupItem(gItem);
            setCustomOriginList([dItem, gItem]);
            offTime = customData[0]?.system_offline_time ? customData[0].system_offline_time : 15;
            emails = customData[0]?.emergency_email ? customData[0].emergency_email.split(',').map(email => email.trim()) : [];
            phones = customData[0]?.emergency_text ? customData[0].emergency_text.split(',').map(phone => {
                const digitsOnly = phone.trim().replace(/\D/g, '');
                return formatPhoneNumber(digitsOnly);
            }) : [];
            setEmailTags(emails);
            setInitialEmailTags(emails);
            setPhoneTags(phones);
            setInitialPhoneTags(phones);
            setInitSysOfflineTime(offTime);
            setSysOfflineTime(offTime);
        }
    }, [customData]);

    useEffect(() => {
        setCustomList([displayItem, groupItem]);
    }, [displayItem, groupItem]);

    useEffect(() => {
        if (arraysEqual(customList, customOriginList)){
            document.getElementById("custom-btn").classList.add("d-none");
            document.getElementById("custom-cancel-btn").classList.add("d-none");
        }else{
            document.getElementById("custom-btn").classList.remove("d-none");
            document.getElementById("custom-cancel-btn").classList.remove("d-none");
        }
    }, [customList, customOriginList]);

    useEffect(() => {
        let accept, finish, reason, releaseT, finishT, clearT, ttl;
        if (configData && configData.length > 0 && configLoaded){
            setAlertSettingId(configData[0]?.alert_setting_id);
            accept = configData[0]?.accept_required === 1;
            finish = configData[0]?.finish_required === 1;
            reason = configData[0]?.reason_required === 1;
            releaseT = configData[0]?.release_timeout ? configData[0].release_timeout/60 : 0;
            finishT = configData[0]?.finish_timeout ? configData[0].finish_timeout/60 : 0;
            clearT = configData[0]?.clear_timeout ? configData[0].clear_timeout/60 : 0;
            ttl = configData[0]?.alert_ttl ? configData[0].alert_ttl/60 : 0;
            setAFRAccept(accept);
            setAFRFinish(finish);
            setAFRReason(reason);
            setRTimeout(releaseT);
            setFTimeout(finishT);
            setCTimeout(clearT);
            setAlertTTL(ttl);
            setAlertListOrigin([accept, finish, reason, releaseT, clearT, finishT, ttl]);
        }
    }, [configData]);

    useEffect(() => {
        setAlertList([afrAccept, afrFinish, afrReason, rTimeout, cTimeout, fTimeout, alertTTL]);
    }, [afrAccept, afrFinish, afrReason, rTimeout, fTimeout, cTimeout, alertTTL]);

    useEffect(() => {
        if (arraysEqual(alertList, alertListOrigin)){
            document.getElementById("alert-btn").classList.add("d-none");
            document.getElementById("alert-cancel-btn").classList.add("d-none");
        }else{
            document.getElementById("alert-btn").classList.remove("d-none");
            document.getElementById("alert-cancel-btn").classList.remove("d-none");
        }
    }, [alertList, alertListOrigin]);

    useEffect(() => {
        if (afrAccept){
            document.getElementById("alert-finish").disabled = false;
        }else{
            setAFRFinish(false);
            setAFRReason(false);
            document.getElementById("alert-finish").disabled = true;
            document.getElementById("alert-reason").disabled = true;
        }
    }, [afrAccept]);

    useEffect(() => {
        if (afrFinish){
            document.getElementById("alert-reason").disabled = false;
        }else{
            setAFRReason(false);
            document.getElementById("alert-reason").disabled = true;
        }
    }, [afrFinish]);

    useEffect(() => {
        let tmp = [];
        if (afrLoaded){
            for (let i=0; i < afrData.length; i++){
                tmp.push(`${afrData[i].device_type_id}-${afrData[i].manufacture_id}`);
            }
            setAFRList(tmp);
            setAFROriginList(tmp);
            setAFRListLoaded(true);
        }
    }, [afrData, afrLoaded]);

    useEffect(() => {
        if (arraysEqual(afrList, afrOriginList)){
            document.getElementById("afr-btn").classList.add("d-none");
            document.getElementById("afr-cancel-btn").classList.add("d-none");
        }else{
            document.getElementById("afr-btn").classList.remove("d-none");
            document.getElementById("afr-cancel-btn").classList.remove("d-none");
        }
    }, [afrList, afrOriginList]);

    useEffect(() => {
        let tmp = [];
        if (priorityLoaded){
            for (let i=0; i < priorityData.length; i++){
                tmp.push(priorityData[i].event_type_id);
            }
            setPriorityList(tmp);
            setPriorityOriginList(tmp);
            setPriorityListLoaded(true);
        }
    }, [priorityData, priorityLoaded]);

    useEffect(() => {
        if (arraysEqual(priorityList, priorityOriginList)){
            document.getElementById("priority-btn").classList.add("d-none");
            document.getElementById("priority-cancel-btn").classList.add("d-none");
        }else{
            document.getElementById("priority-btn").classList.remove("d-none");
            document.getElementById("priority-cancel-btn").classList.remove("d-none");
        }
    }, [priorityList, priorityOriginList]);

    useEffect(() => {
        let tmp = [];
        if (typesLoaded && afrListLoaded && devTypesData.length > 0){
            devTypesData.sort((a,b) => sortFunc(a,b,"device_type_name", "asc"));
            for (let i=0; i < devTypesData.length; i++){
                tmp.push(
                    <li className={"my-1"}>
                        <div className={"form-check form-switch"}>
                            <input className={"form-check-input"} type={"checkbox"}
                                   id={`afr-${devTypesData[i].device_type_name}`}
                                   value={`${devTypesData[i].device_type_id}-${devTypesData[i].manufacture_id}`}
                                   checked={afrList.includes(`${devTypesData[i].device_type_id}-${devTypesData[i].manufacture_id}`)}
                                   onChange={(e) => {
                                       if (e.target.checked){
                                           if (!afrList.includes(e.target.value)){
                                               setAFRList((prevState) => {
                                                   return [...prevState, e.target.value];
                                               });
                                           }
                                       }else{
                                           setAFRList(afrList.filter((item) => {
                                               return item !== e.target.value;
                                           }));
                                       }
                                   }}/>
                            <label className={"form-check-label text-dark"}
                                   htmlFor={`afr-${devTypesData[i].device_type_name}`}>
                                {devTypesData[i].device_type_name}
                            </label>
                        </div>
                    </li>
                );
            }
            setAFRSetList(tmp);
        }
    }, [afrData, devTypesData, afrList, afrListLoaded, typesLoaded]);

    useEffect(() => {
        let tmp = [];
        if (eventTypesLoaded && priorityListLoaded && eventTypeData.length > 0){
            eventTypeData.sort((a,b) => sortFunc(a,b,"event_type_name", "asc"));
            for (let i=0; i < eventTypeData.length; i++){
                tmp.push(
                    <li className={"my-1"}>
                        <div className={"form-check form-switch"}>
                            <input className={"form-check-input"} type={"checkbox"}
                                   id={`priority-${eventTypeData[i].event_type_name}`}
                                   value={eventTypeData[i].event_type_id}
                                   checked={priorityList.includes(eventTypeData[i].event_type_id)}
                                   onChange={(e) => {
                                       if (e.target.checked){
                                           if (!priorityList.includes(parseInt(e.target.value))){
                                               setPriorityList((prevState) => {
                                                   return [...prevState, parseInt(e.target.value)];
                                               });
                                           }
                                       }else{
                                           setPriorityList(priorityList.filter((item) => {
                                               return item !== parseInt(e.target.value);
                                           }));
                                       }
                                   }}/>
                            <label className={"form-check-label text-dark"}
                                   htmlFor={`priority-${eventTypeData[i].event_type_name}`}>
                                {eventTypeData[i].event_type_name}
                            </label>
                        </div>
                    </li>
                );
            }
            setPrioritySetList(tmp);
        }
    }, [priorityData, eventTypeData, priorityList, priorityListLoaded, eventTypesLoaded]);

    useEffect(() => {
        let tmp = [];
        if (globalReasonsLoaded && globalReasons && globalReasons.length > 0){
            for (let i=0; i < globalReasons.length; i++){
                tmp.push(
                    <option key={`category-${i}`} value={globalReasons[i]?.pal_reason_id}>
                        {globalReasons[i]?.pal_reason_description}
                    </option>
                )
            }
            setGlobalOptions(tmp);
        }
    }, [globalReasons]);

    useEffect(() => {
        let tmpData, searchKeys;

        searchKeys = ["preform_note", "display_name"];
        tmpData = searchFunc(preformSearch, preformOriginData, searchKeys);

        setPreformActiveData(tmpData);
    }, [preformSearch, preformOriginData]);

    useEffect(() => {
        if (preformActiveData.length > 0) {
            preformActiveData.sort((a, b) => sortFunc(a, b, preformSorter.sortColumn, preformSorter.sortOrder));
        }
        setPreformTableRows(<TableBody start={0} end={preformActiveData.length} tableData={preformActiveData}
                                       checkbox={true} unk={"pre-"} writeAccess={true} addlEditKey={""} addlEditCheck={false}
                                       actionAppearance={() => actionAppearance(0, preformActiveData.length, ["preformDeleteBtn"], "uCheckPreform")}
                                       tableHeaders={preformHeaderData} editModal={editPreformModal} checkboxId={"uCheckPreform"}
                                       parentComponent={"SystemSettings"} dData={dData} modal={true}
                                       checkboxlist={preformIdList} setCheckboxId={(value) => {setPreformIdList(value)}}
                                       tzOffset={parseInt(dData?.campusData[campusId]?.tz_offset ? dData?.campusData[campusId]?.tz_offset : 0)}
                                       checkidkey={"preform_note_id"} />);
    }, [preformActiveData, preformSorter, preformIdList]);

    useEffect(() => {
        if (reasonData.length > 0) {
            reasonData.sort((a, b) => sortFunc(a, b, reasonSorter.sortColumn, reasonSorter.sortOrder));
        }
        setReasonRows(<TableBody start={0} end={reasonData.length} tableData={reasonData} checkbox={true} unk={"b-"}
                                 writeAccess={true} addlEditKey={""} addlEditCheck={false}
                                 actionAppearance={() => actionAppearance(0, reasonData.length, ["reasonDeleteBtn"], "uCheckReason")}
                                 tableHeaders={reasonHeaderData} editModal={editReasonModal} checkboxId={"uCheckReason"}
                                 parentComponent={"SystemSettings"} dData={dData} modal={true}
                                 checkboxlist={reasonIdList} setCheckboxId={(value) => {setReasonIdList(value)}}
                                 checkidkey={"cloud_reason_code_id"} />);
    }, [reasonData, reasonSorter, reasonIdList]);

    useEffect(() => {
        rangeSliderHandler(rTimeout, "rangeSpan1", "range1");
        rangeSliderHandler(fTimeout, "rangeSpan2", "range2");
        rangeSliderHandler(cTimeout, "rangeSpan3", "range3");
    }, [rTimeout, fTimeout, cTimeout, alertTTL]);

    useEffect(() => {
        
        const hasChanges = !arraysEqual(emailTags, initialEmailTags) || !arraysEqual(phoneTags, initialPhoneTags) || sysOfflineTime !== initSysOfflineTime;
        const saveBtn = document.getElementById("server-btn");
        const cancelBtn = document.getElementById("server-cancel-btn");
        
        if (hasChanges) {
            saveBtn?.classList.remove("d-none");
            cancelBtn?.classList.remove("d-none");
        } else {
            saveBtn?.classList.add("d-none");
            cancelBtn?.classList.add("d-none");
        }
    }, [emailTags, initialEmailTags, phoneTags, initialPhoneTags, sysOfflineTime, initSysOfflineTime]);

    useEffect(() => {
        let tmp = [];
        for (let i=0; i<campusList.length; i++){
            if (campusData[campusList[i]]?.event_notes_active && campusData[campusList[i]]?.event_notes_preform){
                tmp.push(<option key={`event-note-copy-campus-${i}`} value={campusList[i]}>{campusData[campusList[i]]?.name}</option>);
            }
        }
        setCampusCopyOptions(tmp);
    }, [campusData, campusList]);

    function editReasonModal(editIndex){
        let dataIndex;
        dataIndex = parseInt(editIndex);
        setReasonStoredIndex(dataIndex);
        document.getElementById("edit-reason").value = reasonData[dataIndex]?.reason_code_description;
        document.getElementById("edit-category").value = reasonData[dataIndex]?.pal_reason_code_id;
        formCheck("reasonEditForm", "reasonEditSubmit");
        showModal("reasonEditModal");
    }

    function editPreformModal(editIndex){
        let dataIndex;
        dataIndex = parseInt(editIndex);
        setPreformStoredIndex(dataIndex);
        document.getElementById("note").value = preformActiveData[dataIndex]?.preform_note;
        document.getElementById("note").style.height = "125px";
        setOutputOp("Edit");
        formCheck("preformForm", "preformSubmit");
        showModal("preformmodal")
    }

    function reasonAddSubmit(){
        let categoryId, payload, name;
        handleSubmitActions("reasonAddSubmit", "loadReasonAddSubmit");
        name = document.getElementById("add-reason").value;
        categoryId = document.getElementById("add-category").value;
        payload = [{reason_code_description: name, pal_reason_code_id: parseInt(categoryId), campus_id: campusId}];
        ApiRequester({reqEndpoint: "mysave", Tbl: "core_reason_codes", Payload: payload, urlType: "PUT",
                            User: dData.user, PKey: "cloud_reason_code_id", Condition: "primary", CampusId: campusId,
                            ClientId: dData.sessionId}).then(data => {
            if (data && data[0] === true){
                setCount(0);
                formSuccess("Reason code added successfully", "reasonAddSubmit", "loadReasonAddSubmit",
                    "cancelReasonAddBtn");
            }
            else{
                formFail(`Error during save, error code: ${data[1]}`, "reasonAddSubmit", "loadReasonAddSubmit");
            }
        });
    }

    function reasonEditSubmit(){
        let categoryId, name, categoryIdOld, nameOld, payload,  oldPayload, id;
        handleSubmitActions("reasonEditSubmit, loadReasonEditSubmit");
        id = reasonData[reasonStoredIndex]?.cloud_reason_code_id;
        name = document.getElementById("edit-reason").value;
        categoryId = document.getElementById("edit-category").value;
        nameOld = reasonData[reasonStoredIndex].reason_code_description;
        categoryIdOld = reasonData[reasonStoredIndex].pal_reason_code_id;
        payload = [{cloud_reason_code_id: id, campus_id: campusId, pal_reason_code_id: categoryId,
                    reason_code_description: name, modified_by: dData.User}];
        oldPayload = [{cloud_reason_code_id: id, pal_reason_code_id: categoryIdOld, reason_code_description: nameOld,
                       campus_id: campusId}];
        ApiRequester({reqEndpoint: "mysave", Tbl: "core_reason_codes", Payload: payload, urlType: "POST",
                            User: dData.user, PKey: "cloud_reason_code_id", Condition: "primary", CampusId: campusId,
                            ClientId: dData.sessionId, OldPayload: oldPayload}).then(data => {
            if (data && data[0] === true){
                setCount(0);
                formSuccess("Reason code saved successfully", "reasonEditSubmit", "loadReasonEditSubmit",
                    "cancelReasonEditBtn");
            }
            else{
                formFail(`Error during save, error code: ${data[1]}`, "reasonEditSubmit", "loadReasonEditSubmit");
            }
        });
    }

    function customSubmit() {
        let payload, oldPayload;
        handleSubmitActions("custom-btn", "load-custom-btn");
        payload = [{campus_id: campusId, is_name_editable: displayItem ? 1 : 0, is_group_editable: groupItem ? 1 : 0,
                   modified_by: dData.user}];
        oldPayload = [{campus_id: campusId, is_name_editable: customOriginList[0],
                       is_group_editable: customOriginList[1]}];
        ApiRequester({reqEndpoint: "mysave", Tbl: "core_campus", Payload: payload, urlType: "POST",
                            User: dData.user, PKey: "campus_id", Condition: "primary", CampusId: campusId,
                            ClientId: dData.sessionId, OldPayload: oldPayload}).then(data => {
            if (data[0]) {
                setCount(0);
                formSuccess("Custom User Settings Saved", "custom-btn", "load-custom-btn");
            }
            else{
                formFail("Error encountered, save failed", "custom-btn", "load-custom-btn");
            }
        });
    }

    function alertSubmit(){
        let payload, oldPayload, accept, finish, reason, releaseTimer, finishTimer, clearTimer, ttl;
        handleSubmitActions("alert-btn", "load-alert-btn");
        accept = afrAccept ? 1 : 0;
        finish = afrFinish ? 1 : 0;
        reason = afrReason ? 1 : 0;
        releaseTimer = rTimeout * 60;
        finishTimer = fTimeout * 60;
        clearTimer = cTimeout * 60;
        ttl = alertTTL * 60;
        payload = [{alert_setting_id: alertSettingId, campus_id: campusId, accept_required: accept,
                   finish_required: finish, reason_required: reason, release_timeout: releaseTimer,
                   finish_timeout: finishTimer, clear_timeout: clearTimer, alert_ttl: ttl}];
        oldPayload = [{alert_setting_id: alertSettingId, campus_id: campusId, accept_required: alertListOrigin[0],
                      finish_required: alertListOrigin[1], reason_required: alertListOrigin[2],
                      release_timeout: alertListOrigin[3]*60, finish_timeout: alertListOrigin[4]*60,
                      clear_timeout: alertListOrigin[5]*60, alert_ttl: alertListOrigin[6]*60}];
        ApiRequester({reqEndpoint: "mysave", Tbl: "core_campus_alert_settings", Payload: payload, urlType: "POST",
                            User: dData.user, PKey: "alert_setting_id", Condition: "primary", CampusId: campusId,
                            ClientId: dData.sessionId, OldPayload: oldPayload}).then(data => {
            if(data[0]){
                reloadSessionCampusItems(dData.acnt, ["alert_ttl"], [ttl], false)
                setCount(0);
                formSuccess("Alert Behavior Settings Saved", "alert-btn", "load-alert-btn");
            }
            else{
                formFail("Error encountered, save failed", "alert-btn", "load-alert-btn");
            }
        });
    }

    function afrSubmit(){
        let payload, oldPayload;
        handleSubmitActions("afr-btn", "load-afr-btn");
        payload = [{campus_id: campusId, afr_entities: afrList}];
        oldPayload = [{campus_id: campusId, afr_entities: afrOriginList}];
        ApiRequester({reqEndpoint: "mytransaction", TransType: "afrSave", Payload: payload, CampusId: campusId,
                            OldPayload: oldPayload, ClientId: dData.sessionId, User: dData.user}).then(data => {
            if(data[0]){
                setCount(0);
                formSuccess("AFR Devices Saved", "afr-btn", "load-afr-btn");
            }
            else{
                formFail("Error encountered, save failed", "afr-btn", "load-afr-btn");
            }
        });
    }

    function prioritySubmit(){
        let payload, oldPayload;
        handleSubmitActions("priority-btn", "load-priority-btn");
        payload = [{campus_id: campusId, priority_entities: priorityList}];
        oldPayload = [{campus_id: campusId, priority_entities: priorityOriginList}];
        ApiRequester({reqEndpoint: "mytransaction", TransType: "prioritySave", Payload: payload,
                            CampusId: campusId, OldPayload: oldPayload, ClientId: dData.sessionId,
                            User: dData.user}).then(data => {
            if(data[0]){
                setCount(0);
                formSuccess("High Priority Event Types Saved", "priority-btn", "load-priority-btn");
            }
            else{
                formFail("Error encountered, save failed", "priority-btn", "load-priority-btn");
            }
        });
    }

    function serverSubmit(){
        let payload, oldPayload;
        handleSubmitActions("server-btn", "load-server-btn");
        const rawPhoneTags = phoneTags.map(phone => phone.replace(/\D/g, ''));
        const rawInitialPhoneTags = initialPhoneTags.map(phone => phone.replace(/\D/g, ''));
        
        payload = [{
            emergency_email: emailTags.join(","),
            emergency_text: rawPhoneTags.join(","),
            system_offline_time: sysOfflineTime,
            campus_id: campusId
        }];
        oldPayload = [{
            emergency_email: initialEmailTags.join(","),
            emergency_text: rawInitialPhoneTags.join(","),
            system_offline_time: initSysOfflineTime,
            campus_id: campusId
        }];
        ApiRequester({reqEndpoint: "mysave", Tbl: "core_campus", Payload: payload, urlType: "POST",
                            User: dData.user, PKey: "campus_id", Condition: "primary", CampusId: campusId,
                            ClientId: dData.sessionId, OldPayload: oldPayload}).then(data => {
            if(data[0]){
                setCount(0);
                formSuccess("Saved server settings", "server-btn", "load-server-btn");
            }
            else{
                formFail("Error encountered, save failed", "server-btn", "load-server-btn");
            }
        })
    }

    function reasonDeletePerform(submitBtn, loadBtn, closeId, start, end){
        let payload;
        handleSubmitActions(submitBtn, loadBtn);
        payload = [];
        for (let i=0; i < reasonDContent.length; i++){
            payload.push({cloud_reason_code_id: reasonDContent[i][0]});
        }
        ApiRequester({reqEndpoint: "mytransaction", TransType: "reason_delete", Payload: payload,
                            CampusId: campusId, User: dData.user, ClientId: dData.sessionId}).then(data => {
            if (data[0]){
                setCount(0);
                setReasonIdList([]);
                formSuccess("Reasons deleted.", submitBtn, loadBtn, closeId);
                document.getElementById("uCheckHeadReason").checked = false;
                checkAll(start, end);
                actionAppearance(start, end, ["reasonDeleteBtn"], "uCheckReason");
            }
            else{
                formFail(`Error during delete, error code: ${data[1]}`, submitBtn, loadBtn);
            }
        });
    }

    function addPreformSubmit(){
        let payload;
        handleSubmitActions("preformSubmit", "loadPreformSubmit");
        payload = [{
            preform_note: document.getElementById("note").value,
            campus_id: campusId,
            modified_by: dData.user
        }];
        ApiRequester({reqEndpoint: "mysave", Tbl: "core_preform_event_notes", Payload: payload, urlType: "PUT",
                            User: dData.user, PKey: "preform_note_id", Condition: "primary", CampusId: campusId,
                            ClientId: dData.sessionId, OldPayload: []}).then(data => {
            if(data[0]){
                setCount(0);
                formSuccess("Note templated added", "preformSubmit", "loadPreformSubmit", "cancelPreformBtn");
            }
            else{
                formFail("Error encountered, add failed", "preformSubmit", "loadPreformSubmit");
            }
        });
    }

    function editPreformSubmit(){
        let payload, oldPayload;
        handleSubmitActions("preformSubmit", "loadPreformSubmit");
        payload = [{
            preform_note_id: preformActiveData[preformStoredIndex].preform_note_id,
            preform_note: document.getElementById("note").value,
            campus_id: campusId,
            modified_by: dData.user
        }];
        oldPayload = [{
            preform_note: preformActiveData[preformStoredIndex].preform_note
        }];
        ApiRequester({reqEndpoint: "mysave", Tbl: "core_preform_event_notes", Payload: payload, urlType: "POST",
                            User: dData.user, PKey: "preform_note_id", Condition: "primary", CampusId: campusId,
                            ClientId: dData.sessionId, OldPayload: oldPayload}).then(data => {
            if(data[0]){
                setCount(0);
                formSuccess("Note template saved", "preformSubmit", "loadPreformSubmit", "cancelPreformBtn");
            }
            else{
                formFail("Error encountered, save failed", "preformSubmit", "loadPreformSubmit");
            }
        });
    }

    function preformDeletePerform(submitBtn, loadBtn, closeId, start, end){
        let payload;
        payload = [];
        handleSubmitActions(submitBtn, loadBtn);
        for (let i=0; i < preformDContent.length; i++){
            payload.push({preform_note_id: preformDContent[i][0], modified_by: dData.user});
        }
        ApiRequester({reqEndpoint: "mysave", Tbl: "core_preform_event_notes", Payload: payload, urlType: "DELETE",
                            PKey: "preform_note_id", User: dData.user, Condition: "primary", CampusId: dData.acnt}).then(data => {
            if (data[0]){
                formSuccess("Note template deleted.", submitBtn, loadBtn, closeId);
                document.getElementById("uCheckHeadPreform").checked = false;
                checkAll(start, end);
                actionAppearance(start, end, ["preformDeleteBtn"], "uCheckPreform");
            }
            else{
                formFail(data[1], submitBtn, loadBtn);
            }
        });
    }

    function copyPerformSubmit(){
        let payload = [], cId;
        handleSubmitActions("copySubmit", "loadCopySubmit");
        cId = document.getElementById("copy-campus").value;
        payload = [{from_campus_id: parseInt(cId), campus_id: campusId}];
        ApiRequester({reqEndpoint: "mytransaction", TransType: "preform_notes_import", Payload: payload,
                            CampusId: campusId, User: dData.user, ClientId: dData.sessionId}).then(data => {
            if (data[0]){
                setCount(0);
                formSuccess("Note templates imported successfully.", "copySubmit", "loadCopySubmit", "cancelCopyBtn");
            }
            else{
                formFail(`Error importing notes, error code: ${data[1]}`, "copySubmit", "loadCopySubmit");
            }
        });
    }

    const reasonHeaders = <TableHeaders checkbox={true} headerData={reasonHeaderData}
                                        checkAll={() => checkAll(0, reasonData.length, reasonIdList, setReasonIdList, "uCheckHeadReason", "uCheckReason")}
                                        writeAccess={true} sortOrder={reasonSorter.sortOrder} modal_name={"Edit"}
                                        sortColumn={reasonSorter.sortColumn} sorter={reasonSorter} checkboxHeaderId={"uCheckHeadReason"}
                                        setSorter={setReasonSorter} modal={true} checkboxlist={reasonIdList}
                                        actionAppearance={() => actionAppearance(0, reasonData.length, ["reasonDeleteBtn"], "uCheckReason")}/>

    const preformHeaders = <TableHeaders checkbox={true} headerData={preformHeaderData}
                                         checkAll={() => checkAll(0, preformActiveData.length, preformIdList, setPreformIdList, "uCheckHeadPreform", "uCheckPreform")}
                                         writeAccess={true} sortOrder={preformSorter.sortOrder} modal_name={"Edit"}
                                         sortColumn={preformSorter.sortColumn} sorter={preformSorter} checkboxHeaderId={"uCheckHeadPreform"}
                                         setSorter={setPreformSorter} modal={true} checkboxlist={reasonIdList}
                                         actionAppearance={() => actionAppearance(0, preformActiveData.length, ["preformDeleteBtn"], "uCheckPreform")}/>

    const headerContent = (
        <div className={"d-flex justify-content-between"}>
            <div>
            </div>
            <CampusDropDown campusId={campusId} setCampusId={(item) => setCampusId(item)}
                            setCount={(item) => setCount(item)} pageAction={(e) => {
                if (dData?.campusData[campusId.toString()]?.is_cloud !== dData?.campusData[e.target.value]?.is_cloud){
                    window.location.reload();
                }else{
                    setConfigLoaded(false);
                    setLoaded(false);
                }
            }} />
        </div>
    );

    const validateEmail = (email) => {
        return /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(email);
    };

    const handleEmailValidation = (email) => {
        if (!email) {
            setEmailError("");
            setIsEmailValid(true);
            return false;
        }
        
        if (!validateEmail(email)) {
            setEmailError("Please enter a valid email address");
            setIsEmailValid(false);
            return false;
        }
        
        // Check for duplicates case-insensitively
        if (emailTags.some(existingEmail => existingEmail.toLowerCase() === email.toLowerCase())) {
            setEmailError("This email is already in the list");
            setIsEmailValid(false);
            return false;
        }
        
        setEmailError("");
        setIsEmailValid(true);
        return true;
    };

    const handleEmailKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ',') {
            e.preventDefault();
            const email = e.target.value.trim();
            
            // Check for duplicates before adding
            if (email && !emailTags.some(existingEmail => existingEmail.toLowerCase() === email.toLowerCase())) {
                if (handleEmailValidation(email)) {
                    setEmailTags([...emailTags, email]);
                    e.target.value = '';
                    setEmailError("");
                }
            } else if (email) {
                setEmailError("This email is already in the list");
                setIsEmailValid(false);
            }
        }
    };

    const handleEmailBlur = (e) => {
        const email = e.target.value.trim();
        
        // Check for duplicates before adding
        if (email && !emailTags.some(existingEmail => existingEmail.toLowerCase() === email.toLowerCase())) {
            if (handleEmailValidation(email)) {
                setEmailTags([...emailTags, email]);
                e.target.value = '';
                setEmailError("");
            }
        } else if (email) {
            setEmailError("This email is already in the list");
            setIsEmailValid(false);
        }
        e.target.value = '';
    };

    const handleEmailChange = (e) => {
        const email = e.target.value.trim();
        if (email) {
            // Check for duplicates as user types
            if (emailTags.some(existingEmail => existingEmail.toLowerCase() === email.toLowerCase())) {
                setEmailError("This email is already in the list");
                setIsEmailValid(false);
            } else {
                handleEmailValidation(email);
            }
        } else {
            setEmailError("");
            setIsEmailValid(true);
        }
    };

    const removeEmail = (emailToRemove) => {
        setEmailTags(emailTags.filter(email => email !== emailToRemove));
    };

    const sysHandleCancel = () => {
        setEmailTags([...initialEmailTags]);
        setPhoneTags([...initialPhoneTags]);
        setSysOfflineTime(initSysOfflineTime);
    };

    const validatePhone = (phone) => {
        // Remove any non-digit characters for validation
        const digitsOnly = phone.replace(/\D/g, '');
        return /^\d{10}$/.test(digitsOnly);
    };

    const formatPhoneNumber = (phone) => {
        // Remove any non-digit characters
        const digitsOnly = phone.replace(/\D/g, '');
        // Format as (XXX) XXX-XXXX
        return `(${digitsOnly.slice(0, 3)}) ${digitsOnly.slice(3, 6)}-${digitsOnly.slice(6)}`;
    };

    const handlePhoneValidation = (phone) => {
        if (!phone) {
            setPhoneError("");
            setIsPhoneValid(true);
            return false;
        }
        
        const digitsOnly = phone.replace(/\D/g, '');
        if (!validatePhone(digitsOnly)) {
            setPhoneError("Please enter a valid 10-digit phone number");
            setIsPhoneValid(false);
            return false;
        }
        
        // Check for duplicates case-insensitively
        if (phoneTags.some(existingPhone => existingPhone.replace(/\D/g, '') === digitsOnly)) {
            setPhoneError("This phone number is already in the list");
            setIsPhoneValid(false);
            return false;
        }
        
        setPhoneError("");
        setIsPhoneValid(true);
        return true;
    };

    const handlePhoneKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ',') {
            e.preventDefault();
            const phone = e.target.value.trim();
            const digitsOnly = phone.replace(/\D/g, '');
            
            // Check for duplicates before adding
            if (phone && !phoneTags.some(existingPhone => existingPhone.replace(/\D/g, '') === digitsOnly)) {
                if (handlePhoneValidation(digitsOnly)) {
                    setPhoneTags([...phoneTags, formatPhoneNumber(digitsOnly)]);
                    e.target.value = '';
                    setPhoneError("");
                }
            } else if (phone) {
                setPhoneError("This phone number is already in the list");
                setIsPhoneValid(false);
            }
        }
    };

    const handlePhoneBlur = (e) => {
        const phone = e.target.value.trim();
        const digitsOnly = phone.replace(/\D/g, '');
        
        // Check for duplicates before adding
        if (phone && !phoneTags.some(existingPhone => existingPhone.replace(/\D/g, '') === digitsOnly)) {
            if (handlePhoneValidation(digitsOnly)) {
                setPhoneTags([...phoneTags, formatPhoneNumber(digitsOnly)]);
                e.target.value = '';
                setPhoneError("");
            }
        } else if (phone) {
            setPhoneError("This phone number is already in the list");
            setIsPhoneValid(false);
        }
        e.target.value = '';
    };

    const handlePhoneChange = (e) => {
        const phone = e.target.value.trim();
        const digitsOnly = phone.replace(/\D/g, '');
        
        if (phone) {
            // Check for duplicates as user types
            if (phoneTags.some(existingPhone => existingPhone.replace(/\D/g, '') === digitsOnly)) {
                setPhoneError("This phone number is already in the list");
                setIsPhoneValid(false);
            } else {
                handlePhoneValidation(digitsOnly);
            }
        } else {
            setPhoneError("");
            setIsPhoneValid(true);
        }
    };

    const removePhone = (phoneToRemove) => {
        setPhoneTags(phoneTags.filter(phone => phone !== phoneToRemove));
    };

    return (
        <>
            <Navigation/>
            <div className={"main-content"}>
                <Header preTitle={"Settings 4.0"} Title={"System Settings"} content={headerContent}/>
                <div className={"container-fluid"}>
                    <div
                        className={`row align-items-center ${isBannerPresent() ? "sticky-table-headX" : "sticky-table-head"}`}
                        style={{backgroundColor: "#f9fbfd", zIndex: 2}}>
                        <div className={"col"}>
                            <ul className={"nav nav-tabs nav-overflow header-tabs"}>
                                <li key={"set-alert"} className={"nav-item"}>
                                    <Button text={"Alert Behavior"}
                                            class={tabItem === "alert" ? "nav-link active" : "nav-link"}
                                            onClick={() => setTabItem("alert")}/>
                                </li>
                                <li key={"set-custom"} className={"nav-item"}>
                                    <Button text={"Customizations"}
                                            class={tabItem === "custom" ? "nav-link active" : "nav-link"}
                                            onClick={() => setTabItem("custom")}/>
                                </li>
                                <li key={"set-priority"} className={"nav-item"}>
                                    <Button text={"High Priority Alerts"}
                                            class={tabItem === "priority" ? "nav-link active" : "nav-link"}
                                            onClick={() => setTabItem("priority")}/>
                                </li>
                                <li key={"set-device"} className={"nav-item"}>
                                    <Button text={"Accept/Finish Devices"}
                                            class={tabItem === "afr" ? "nav-link active" : "nav-link"}
                                            onClick={() => setTabItem("afr")}/>
                                </li>
                                <li key={"set-reason"} className={"nav-item"}>
                                    <Button text={"Custom Reasons"}
                                            class={tabItem === "reason" ? "nav-link active" : "nav-link"}
                                            onClick={() => setTabItem("reason")}/>
                                </li>
                                {dData?.event_notes_active && dData?.event_notes_preform
                                    ?   <li key={"set-preform"} className={"nav-item"}>
                                            <Button text={"Event Note Templates"}
                                                    class={tabItem === "preform" ? "nav-link active" : "nav-link"}
                                                    onClick={() => setTabItem("preform")}/>
                                        </li>
                                    :   <></>
                                }
                                <li key={"set-server"} className={"nav-item"}>
                                    <Button text={"Server"}
                                            class={tabItem === "server" ? "nav-link active" : "nav-link"}
                                            onClick={() => setTabItem("server")}/>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className={tabItem === "init" ? "d-block" : "d-none"}>
                        <p>System settings loading. . .</p>
                    </div>
                    <div className={tabItem === "alert" ? "d-block" : "d-none"}>
                        <div className={"card"} style={{maxWidth: "1200px", minWidth: "600px"}}>
                            <div className={"card-header"}>
                                <h4 className={"card-header-title"}>Alert Behavior Settings</h4>
                                <Button text={"Cancel"} id={"alert-cancel-btn"} class={"btn btn-secondary d-none me-3"}
                                        onClick={() => {
                                            setAFRAccept(alertListOrigin[0]);
                                            setAFRFinish(alertListOrigin[1]);
                                            setAFRReason(alertListOrigin[2]);
                                            setRTimeout(alertListOrigin[3]);
                                            setCTimeout(alertListOrigin[4]);
                                            setFTimeout(alertListOrigin[5]);
                                            setAlertTTL(alertListOrigin[6]);
                                        }}/>
                                <Button type={"button"} class={"btn btn-primary d-none ms-3"} disabled={true}
                                        spinner={true} text={"Saving"} id={"load-alert-btn"}/>
                                <Button icon={true} iconClass={"fe fe-edit me-2"} text={"Save"} id={"alert-btn"}
                                        class={"btn btn-primary d-none"} onClick={() => alertSubmit()}/>
                            </div>
                            <div className={"card-body"}>
                                <div className={"list-group list-group-flush my-3"}>
                                    <div className={"list-group-item pt-0"}>
                                        <div className={"row align-items-center"}>
                                            <div className={"col"}>
                                                <h4 className={"font-weight-base mb-1 d-inline-block"}
                                                    style={{width: "170px"}}>Max Alert Timeout (min)</h4>
                                                <input className={"form-control form-text range-input text-dark"}
                                                       max={360} min={60} step={5}
                                                       type={"number"} value={alertTTL}
                                                       onBlur={(e) => {
                                                           if (!e.target.value || isNaN(e.target.value) || parseInt(e.target.value) < 60){
                                                               setAlertTTL(60);
                                                           }else if (parseInt(e.target.value) > 360){
                                                               setAlertTTL(360);
                                                           }else{
                                                               if (parseInt(e.target.value) % 5 !== 0){
                                                                   e.target.stepUp();
                                                                   setAlertTTL(parseInt(e.target.value));
                                                               }else{
                                                                   setAlertTTL(parseInt(e.target.value));
                                                               }
                                                           }
                                                       }}
                                                       onChange={(e) => {
                                                            setAlertTTL(parseInt(e.target.value));
                                                       }}/>
                                                <p className={"text-muted d-block"}>Max length of time alerts stay active in system.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={"list-group-item"}>
                                        <div className={"form-check form-switch"}>
                                            <input className={"form-check-input"} type={"checkbox"}
                                                   id={"alert-accept"} checked={afrAccept}
                                                   onChange={(e) => {
                                                       setAFRAccept(e.target.checked);
                                                   }}/>
                                            <label className={"form-check-label text-dark"}
                                                   htmlFor={"alert-accept"}>
                                                Accept Alerts
                                            </label>
                                        </div>
                                        <p className={"text-muted"}>Users must accept alerts being responded to.</p>
                                        <div className={"form-check form-switch"}>
                                            <input className={"form-check-input"} type={"checkbox"}
                                                   id={"alert-finish"} checked={afrFinish}
                                                   onChange={(e) => {
                                                       setAFRFinish(e.target.checked);
                                                   }}/>
                                            <label className={"form-check-label text-dark"}
                                                   htmlFor={"alert-finish"}>
                                                Finish Alerts
                                            </label>
                                        </div>
                                        <p className={"text-muted"}>User must mark when they are completed with an
                                            alert</p>
                                        <div className={"form-check form-switch"}>
                                            <input className={"form-check-input"} type={"checkbox"}
                                                   id={"alert-reason"} checked={afrReason}
                                                   onChange={(e) => {
                                                       setAFRReason(e.target.checked);
                                                   }}/>
                                            <label className={"form-check-label text-dark"}
                                                   htmlFor={"alert-reason"}>
                                                Record Reason
                                            </label>
                                        </div>
                                        <p className={"text-muted"}>Users must accept alerts being responded to.</p>
                                    </div>
                                    <div className={"list-group-item"}>
                                        <div className={"row align-items-center"}>
                                            <div className={"col"}>
                                                <h4 className={"font-weight-base mb-1 d-inline-block"}
                                                    style={{width: "120px"}}>Release Timeout</h4>
                                                <input className={"form-control form-text range-input"} max={alertTTL} min={1}
                                                       type={"number"} placeholder={rTimeout} onBlur={(e) => {
                                                    if (parseInt(e.target.value) >= parseInt(e.target.min) && parseInt(e.target.value) <= parseInt(e.target.max)) {
                                                        setRTimeout(parseInt(e.target.value));
                                                    }
                                                    e.target.value = "";
                                                }}/>
                                                <p className={"text-muted d-block"}>Time to release alert after accepted
                                                    with no
                                                    device clear.</p>
                                                <div className={"range-container"}>
                                                    <span id={"rangeSpan1"}>{rTimeout} Min</span>
                                                    <input id={"range1"} className={"form-range"} type={"range"}
                                                           min={"1"}
                                                           step={"1"} max={alertTTL} value={rTimeout}
                                                           onChange={(e) => {
                                                               setRTimeout(parseInt(e.target.value));
                                                           }}/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={"list-group-item"}>
                                        <div className={"row align-items-center"}>
                                            <div className={"col"}>
                                                <h4 className={"font-weight-base mb-1 d-inline-block"}
                                                    style={{width: "120px"}}>Clear Timeout</h4>
                                                <input className={"form-control form-text range-input"} max={alertTTL-1} min={4}
                                                       type={"number"} placeholder={cTimeout}
                                                       onBlur={(e) => {
                                                           if (parseInt(e.target.value) >= parseInt(e.target.min) && parseInt(e.target.value) <= parseInt(e.target.max)) {
                                                               setCTimeout(parseInt(e.target.value));
                                                               if (parseInt(e.target.value) >= fTimeout) {
                                                                   setFTimeout(parseInt(e.target.value) + 1);
                                                               }
                                                           }
                                                           e.target.value = "";
                                                       }}/>
                                                <p className={"text-muted d-block"}>Time to autoclear alert after no
                                                    contact
                                                    from
                                                    system.</p>
                                                <div className={"range-container"}>
                                                    <span id={"rangeSpan3"}>{cTimeout} Min</span>
                                                    <input id={"range3"} className={"form-range"} type={"range"}
                                                           min={"4"}
                                                           step={"1"} max={alertTTL-1} value={cTimeout}
                                                           onChange={(e) => {
                                                               setCTimeout(parseInt(e.target.value));
                                                               if (parseInt(e.target.value) >= fTimeout) {
                                                                   setFTimeout(parseInt(e.target.value) + 1);
                                                               }
                                                           }}/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={"list-group-item"}>
                                        <div className={"row align-items-center"}>
                                            <div className={"col"}>
                                                <h4 className={"font-weight-base mb-1 d-inline-block"}
                                                    style={{width: "120px"}}>Finish Timeout</h4>
                                                <input className={"form-control form-text range-input"} max={alertTTL} min={5}
                                                       type={"number"} placeholder={fTimeout}
                                                       onBlur={(e) => {
                                                           if (parseInt(e.target.value) >= parseInt(e.target.min) && parseInt(e.target.value) <= parseInt(e.target.max)) {
                                                               setFTimeout(parseInt(e.target.value));
                                                               if (parseInt(e.target.value) <= cTimeout && cTimeout >= parseInt(e.target.min)) {
                                                                   setCTimeout(parseInt(e.target.value) - 1);
                                                               }
                                                           }
                                                           e.target.value = "";
                                                       }}/>
                                                <p className={"text-muted d-block"}>Time to auto finish alarm if stale
                                                    after
                                                    accept
                                                    and clear.</p>
                                                <div className={"range-container"}>
                                                    <span id={"rangeSpan2"}>{fTimeout} Min</span>
                                                    <input id={"range2"} className={"form-range"} type={"range"}
                                                           min={"5"}
                                                           step={"1"} max={alertTTL} value={fTimeout}
                                                           onChange={(e) => {
                                                               if (parseInt(e.target.value) >= parseInt(e.target.min) && parseInt(e.target.value) <= parseInt(e.target.max)) {
                                                                   setFTimeout(parseInt(e.target.value));
                                                                   if (parseInt(e.target.value) <= cTimeout && cTimeout >= parseInt(e.target.min)) {
                                                                       setCTimeout(parseInt(e.target.value) - 1)
                                                                   }
                                                               }
                                                           }}/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={tabItem === "custom" ? "d-block" : "d-none"}>
                        <div className={"card"} style={{maxWidth: "1200px", minWidth: "600px"}}>
                            <div className={"card-header"}>
                                <h4 className={"card-header-title"}>User Customizations</h4>
                                <Button text={"Cancel"} id={"custom-cancel-btn"}
                                        class={"btn btn-secondary d-none me-3"}
                                        onClick={() => {
                                            setDisplayItem(customOriginList[0]);
                                            setGroupItem(customOriginList[1]);
                                        }}/>
                                <Button type={"button"} class={"btn btn-primary d-none ms-3"} disabled={true}
                                        spinner={true} text={"Saving"} id={"load-custom-btn"}/>
                                <Button icon={true} iconClass={"fe fe-edit me-2"} text={"Save"} id={"custom-btn"}
                                        class={"btn btn-primary d-none"} onClick={() => customSubmit()}/>
                            </div>
                            <div className={"card-body"}>
                                <div className={"list-group list-group-flush my-3"}>
                                    <div className={"list-group-item pt-0"}>
                                        <div className={"form-check form-switch"}>
                                            <input className={"form-check-input"} type={"checkbox"}
                                                   id={"custom-display"} checked={displayItem}
                                                   onChange={(e) => {
                                                       setDisplayItem(e.target.checked);
                                                   }}/>
                                            <label className={"form-check-label text-dark"}
                                                   htmlFor={"alert-accept"}>
                                                Display Name
                                            </label>
                                        </div>
                                        <p className={"text-muted"}>User can change their display name.</p>
                                        <div className={"form-check form-switch"}>
                                            <input className={"form-check-input"} type={"checkbox"}
                                                   id={"alert-finish"} checked={groupItem}
                                                   onChange={(e) => {
                                                       setGroupItem(e.target.checked);
                                                   }}/>
                                            <label className={"form-check-label text-dark"}
                                                   htmlFor={"alert-finish"}>
                                                Group
                                            </label>
                                        </div>
                                        <p className={"text-muted"}>User can change the group of alerts they
                                            receive.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={tabItem === "priority" ? "d-block" : "d-none"}>
                        <div className={"card"} style={{maxWidth: "1200px", minWidth: "600px"}}>
                            <div className={"card-header"}>
                                <h4 className={"card-header-title"}>High Priority Alert Types</h4>
                                <Button text={"Cancel"} id={"priority-cancel-btn"}
                                        class={"btn btn-secondary d-none me-3"}
                                        onClick={() => setPriorityList(priorityOriginList)}/>
                                <Button type={"button"} class={"btn btn-primary d-none ms-3"} disabled={true}
                                        spinner={true} text={"Saving"} id={"load-priority-btn"}/>
                                <Button icon={true} iconClass={"fe fe-edit me-2"} text={"Save"} id={"priority-btn"}
                                        class={"btn btn-primary d-none"} onClick={() => prioritySubmit()}/>
                            </div>
                            <div className={"card-body"}>
                                <ul className={"my-3"} style={{listStyle: "none", columns: 2, columnFill: "balance"}}>
                                    {prioritySetList}
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className={tabItem === "afr" ? "d-block" : "d-none"}>
                        <div className={"card"} style={{maxWidth: "1200px", minWidth: "600px"}}>
                            <div className={"card-header"}>
                                <h4 className={"card-header-title"}>Accept Finish Reason Devices (Default)</h4>
                                <Button text={"Cancel"} id={"afr-cancel-btn"}
                                        class={"btn btn-secondary d-none me-3"}
                                        onClick={() => setAFRList(afrOriginList)}/>
                                <Button type={"button"} class={"btn btn-primary d-none ms-3"} disabled={true}
                                        spinner={true} text={"Saving"} id={"load-afr-btn"}/>
                                <Button icon={true} iconClass={"fe fe-edit me-2"} text={"Save"} id={"afr-btn"}
                                        class={"btn btn-primary d-none"} onClick={() => afrSubmit()}/>
                            </div>
                            <div className={"card-body"}>
                                <ul className={"my-3"} style={{listStyle: "none", columns: 2, columnFill: "balance"}}>
                                    {afrSetList}
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className={tabItem === "reason" ? "d-block" : "d-none"}>
                        <div className={"card"}>
                            <div className={"card-header"}>
                                <h4 className={"card-header-title"}>Reason Codes</h4>
                                <Button text={"Delete"} type={"button"} class={"btn btn-danger ms-2 hide mt-1"}
                                        id={"reasonDeleteBtn"} icon={true} iconClass={"fe fe-trash-2 me-2"}
                                        onClick={() => bulkDeleteModal(0, reasonData.length, reasonData,
                                            "reason_code_description", ["cloud_reason_code_id", ""], "",
                                                    setReasonDContent, "Are you sure you wish to delete the following reason options? \n",
                                                    "reason-delete", "reasonModalContent", "uCheckReason")}/>
                                <Button icon={true} iconClass={"fe fe-plus me-2"} text={"Reason"}
                                        class={"btn btn-primary ms-4"}
                                        onClick={() => {
                                            document.getElementById("add-reason").value = "";
                                            formCheck("reasonAddForm", "reasonAddSubmit");
                                            showModal("reasonAddModal");
                                        }}/>
                            </div>
                            <div className={"card-body"}>
                                <table className={"table table-sm table-responsive-sm table-hover"}>
                                    <thead className={"table-header"}>
                                    {reasonHeaders}
                                    </thead>
                                    <tbody>
                                    {reasonRows}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    {dData?.event_notes_active && dData?.event_notes_preform
                        ?   <div className={tabItem === "preform" ? "d-block" : "d-none"}>
                                <div className={"card"}>
                                    <div className={"card-header"}>
                                        <h4 className={"card-header-title"}>Preset Event Note Templates</h4>
                                        <Button text={"Delete"} type={"button"} class={"btn btn-danger ms-2 hide mt-1"}
                                                id={"preformDeleteBtn"} icon={true} iconClass={"fe fe-trash-2 me-2"}
                                                onClick={() => bulkDeleteModal(0, preformActiveData.length, preformActiveData,
                                                    "preform_note", ["preform_note_id", ""], "",
                                                    setPreformDContent, "Are you sure you wish to delete the following note templates? \n",
                                                    "preform-delete", "preformModalContent", "uCheckPreform")}/>
                                        {iAmHigherAuthority(30, dData?.role_weight)
                                            ? <Button icon={true} iconType={"google-symbols"} iconClass={"me-2"} text={"Campus Import"}
                                                class={"btn btn-primary ms-4"} iconName={"move_group"} iconColor={"#FFFFFFFF"}
                                                onClick={() => {
                                                    document.getElementById("copy-campus").value = null;
                                                    showModal("copymodal");
                                                }}/>
                                            : <></>
                                        }
                                        <Button icon={true} iconClass={"fe fe-plus me-2"} text={"Note Template"}
                                                class={"btn btn-primary ms-4"}
                                                onClick={() => {
                                                    document.getElementById("note").value = "";
                                                    document.getElementById("note").style.height = "125px";
                                                    setOutputOp("Add");
                                                    formCheck("preformForm", "preformSubmit");
                                                    showModal("preformmodal");
                                                }}/>
                                    </div>
                                    <div className={"card-body"}>
                                        <table className={"table table-sm table-responsive-sm table-hover"}>
                                            <thead className={"table-header"}>
                                            {preformHeaders}
                                            </thead>
                                            <tbody>
                                            {preformTableRows}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        :   <></>
                    }
                    <div className={tabItem === "server" ? "d-block" : "d-none"}>
                        <div className={"card"} style={{maxWidth: "1200px", minWidth: "600px"}}>
                            <div className={"card-header"}>
                                <h4 className={"card-header-title"}>Server Settings</h4>
                                <Button text={"Cancel"} id={"server-cancel-btn"}
                                        class={"btn btn-secondary d-none me-3"}
                                        onClick={sysHandleCancel}/>
                                <Button type={"button"} class={"btn btn-primary d-none ms-3"} disabled={true}
                                        spinner={true} text={"Saving"} id={"load-server-btn"}/>
                                <Button icon={true} iconClass={"fe fe-edit me-2"} text={"Save"} id={"server-btn"}
                                        class={"btn btn-primary d-none"} onClick={() => serverSubmit()}/>
                            </div>
                            <div className={"card-body"}>
                                <form className={"was-validated"}>
                                    <div className={"list-group list-group-flush my-n3"}>
                                        <div className={"list-group-item"}>
                                            <div className={"form-group"} style={{maxWidth: "600px", minWidth: "150px"}}>
                                                <label className={"form-label"}>System Offline Time (minutes)</label>
                                                <input type={"number"} className={"form-control w-25"} min={10} max={60}
                                                       value={sysOfflineTime || ""}
                                                       onChange={(e) => {
                                                           const value = parseInt(e.target.value);
                                                           if (value >= 10 && value <= 60) {
                                                               setSysOfflineTime(value);
                                                           }
                                                       }}
                                                       placeholder={"Enter system offline time in minutes 10-60"}/>
                                                <small className={"text-muted"}>
                                                    Time in minutes before the system is considered offline.
                                                </small>
                                            </div>
                                        </div>
                                        <div className={"list-group-item"}>
                                            <div className={"form-group"} style={{maxWidth: "600px"}}>
                                                <label className={"form-label"}>System Offline Notification Email Addresses</label>
                                                <div className={`border rounded p-2 d-flex ${!isEmailValid ? 'border-danger' : ''} ${emailTags.length > 0 ? " mb-2" : ""}`}
                                                     style={{minHeight: "38px", backgroundColor: "#fff"}}>
                                                    {emailTags.map((email, index) => (
                                                        <span key={'email-tag-'+index} className={"badge bg-primary me-1 mb-1"}>
                                                            {email}
                                                            <button type="button" 
                                                                    className={"btn-close btn-close-white ms-1"} 
                                                                    style={{fontSize: "0.5rem"}}
                                                                    onClick={() => removeEmail(email)}
                                                                    aria-label="Remove email">
                                                            </button>
                                                        </span>
                                                    ))}
                                                    <input type="email"
                                                           ref={emailInputRef}
                                                           className={`border-0 flex-grow-1 ${!isEmailValid ? 'is-invalid' : ''}`}
                                                           style={{outline: "none", minWidth: "200px"}}
                                                           placeholder={emailTags.length === 0 ? "Enter email addresses..." : ""}
                                                           onKeyDown={handleEmailKeyDown}
                                                           onChange={handleEmailChange}
                                                           onBlur={handleEmailBlur}
                                                    />
                                                </div>
                                                {emailError && (
                                                    <div className="invalid-feedback d-block">
                                                        {emailError}
                                                    </div>
                                                )}
                                                <small className={"text-muted"}>
                                                    Press Enter or comma to add an email address. Click the X to remove an email.
                                                </small>
                                            </div>
                                        </div>
                                        <div className={"list-group-item"}>
                                            <div className={"form-group"} style={{maxWidth: "600px"}}>
                                                <label className={"form-label"}>System Offline Notification Phone Numbers</label>
                                                <div className={`border rounded p-2 d-flex ${!isPhoneValid ? 'border-danger' : ''} ${phoneTags.length > 0 ? " mb-2" : ""}`}
                                                     style={{minHeight: "38px", backgroundColor: "#fff"}}>
                                                    {phoneTags.map((phone, index) => (
                                                        <span key={'phone-tag-'+index} className={"badge bg-primary me-1 mb-1"}>
                                                            {phone}
                                                            <button type="button" 
                                                                    className={"btn-close btn-close-white ms-1"} 
                                                                    style={{fontSize: "0.5rem"}}
                                                                    onClick={() => removePhone(phone)}
                                                                    aria-label="Remove phone">
                                                            </button>
                                                        </span>
                                                    ))}
                                                    <input type="tel"
                                                           ref={phoneInputRef}
                                                           className={`border-0 flex-grow-1 ${!isPhoneValid ? 'is-invalid' : ''}`}
                                                           style={{outline: "none", minWidth: "200px"}}
                                                           placeholder={phoneTags.length === 0 ? "Enter phone numbers..." : ""}
                                                           onKeyDown={handlePhoneKeyDown}
                                                           onChange={handlePhoneChange}
                                                           onBlur={handlePhoneBlur}
                                                    />
                                                </div>
                                                {phoneError && (
                                                    <div className="invalid-feedback d-block">
                                                        {phoneError}
                                                    </div>
                                                )}
                                                <small className={"text-muted"}>
                                                    Press Enter or comma to add a phone number. Click the X to remove a number. Numbers will be formatted as (XXX) XXX-XXXX.
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className={"modal fade"} id={"reasonAddModal"} data-bs-backdrop={"static"}
                         data-bs-keyboard={"false"}
                         tabIndex={-1} aria-labelledby={"staticBackdropLabel"} aria-hidden={"true"}>
                        <div className={"modal-dialog"}>
                            <div className={"modal-content"}>
                                <div className={"modal-header bg-pal"}>
                                    <h2 className={"modal-title"} id={"staticBackdropLabel"}>Add Custom Reason</h2>
                                    <button type={"button"} className={"btn-close"} id={"editClose"}
                                            data-bs-dismiss={"modal"} aria-label={"Close"}/>
                                </div>
                                <div className={"modal-body"}>
                                    <form id={"reasonAddForm"}>
                                        <div className={"list-group list-group-flush my-n3 was-validated"}>
                                            <h4>Reason {reasonData.length + 1}</h4>
                                            <div className={"form-floating mb-3"}>
                                                <input className={"form-control"} id={"add-reason"} required={true}
                                                       pattern={"^[0-9a-zA-Z_\\- ]+$"}
                                                       onKeyUp={() => formCheck("reasonAddForm", "reasonAddSubmit")}/>
                                                <label className={"floatingInput"} htmlFor={"add-reason"}>
                                                    Reason Name
                                                </label>
                                            </div>
                                            <div className={"form-floating"}>
                                                <select className={"form-select"} id={"add-category"} required={true}
                                                        onChange={() => {
                                                            formCheck("reasonAddForm", "reasonAddSubmit");
                                                        }}>
                                                    {globalOptions}
                                                </select>
                                                <label htmlFor={"add-category"}>
                                                    Reason Category
                                                </label>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className={"modal-footer"}>
                                    <button type={"button"} className={"btn btn-secondary"} id={"cancelReasonAddBtn"}
                                            data-bs-dismiss={"modal"}>Cancel
                                    </button>
                                    <Button type={"button"} class={"btn btn-primary d-none ms-3"} disabled={true}
                                            spinner={true}
                                            text={"Loading"} id={"loadReasonAddSubmit"}/>
                                    <Button type={"button"} class={"btn btn-primary ms-3"} id={"reasonAddSubmit"}
                                            onClick={() => reasonAddSubmit()}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={"modal fade"} id={"reasonEditModal"} data-bs-backdrop={"static"}
                         data-bs-keyboard={"false"}
                         tabIndex={-1} aria-labelledby={"staticBackdropLabel"} aria-hidden={"true"}>
                        <div className={"modal-dialog"}>
                            <div className={"modal-content"}>
                                <div className={"modal-header bg-pal"}>
                                    <h2 className={"modal-title"} id={"staticBackdropLabel"}>Edit Reason</h2>
                                    <button type={"button"} className={"btn-close"} id={"editClose"}
                                            data-bs-dismiss={"modal"} aria-label={"Close"}/>
                                </div>
                                <div className={"modal-body"}>
                                    <form id={"reasonEditForm"}>
                                        <div className={"list-group list-group-flush my-n3 was-validated"}>
                                            <h4>Reason {reasonData.length + 1}</h4>
                                            <div className={"form-floating mb-3"}>
                                                <input className={"form-control"} id={"edit-reason"} required={true}
                                                       pattern={"^[0-9a-zA-Z_\\- ]+$"}
                                                       onKeyUp={() => formCheck("reasonEditForm", "reasonEditSubmit")}/>
                                                <label className={"floatingInput"} htmlFor={"edit-reason"}>
                                                    Reason Name
                                                </label>
                                            </div>
                                            <div className={"form-floating"}>
                                                <select className={"form-select"} id={"edit-category"} required={true}
                                                        onChange={() => {
                                                            formCheck("reasonEditForm", "reasonEditSubmit");
                                                        }}>
                                                    {globalOptions}
                                                </select>
                                                <label htmlFor={"edit-category"}>
                                                    Reason Category
                                                </label>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className={"modal-footer"}>
                                    <button type={"button"} className={"btn btn-secondary"} id={"cancelReasonEditBtn"}
                                            data-bs-dismiss={"modal"}>Cancel
                                    </button>
                                    <Button type={"button"} class={"btn btn-primary d-none ms-3"} disabled={true}
                                            spinner={true}
                                            text={"Loading"} id={"loadReasonEditSubmit"}/>
                                    <Button type={"button"} class={"btn btn-primary ms-3"} id={"reasonEditSubmit"}
                                            onClick={() => reasonEditSubmit()}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={"modal fade"} id={"preformmodal"} data-bs-backdrop={"static"}
                         data-bs-keyboard={"false"}
                         tabIndex={-1} aria-labelledby={"staticBackdropLabel"} aria-hidden={"true"}>
                        <div className={"modal-dialog"}>
                            <div className={"modal-content"}>
                                <div className={"modal-header bg-pal"}>
                                    <h2 className={"modal-title"} id={"staticBackdropLabel"}>{outputOp} Note Template</h2>
                                    <button type={"button"} className={"btn-close"} id={"preformClose"}
                                            data-bs-dismiss={"modal"} aria-label={"Close"}/>
                                </div>
                                <div className={"modal-body"}>
                                    <form id={"preformForm"}>
                                        <div className={"my-2 form-floating"}>
                                            <textarea className={"form-control pt-5"} id={"note"} required={true} onKeyUp={() => formCheck("preformForm", "preformSubmit")}>

                                            </textarea>
                                            <label htmlFor={"note"} className={"form-label"}>Note</label>
                                            <div className={"invalid-feedback"}>
                                                Note required
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className={"modal-footer"}>
                                    <button type={"button"} className={"btn btn-secondary"} id={"cancelPreformBtn"}
                                            data-bs-dismiss={"modal"}>Cancel
                                    </button>
                                    <Button type={"button"} class={"btn btn-primary d-none ms-3"} disabled={true}
                                            spinner={true} text={"Loading"} id={"loadPreformSubmit"}/>
                                    <Button type={"button"} class={"btn btn-primary ms-3"} id={"preformSubmit"}
                                            onClick={() => {
                                                if (outputOp === "Edit"){
                                                    editPreformSubmit();
                                                }else{
                                                    addPreformSubmit();
                                                }
                                            }}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={"modal fade"} id={"copymodal"} data-bs-backdrop={"static"}
                         data-bs-keyboard={"false"}
                         tabIndex={-1} aria-labelledby={"staticBackdropLabel"} aria-hidden={"true"}>
                        <div className={"modal-dialog"}>
                            <div className={"modal-content"}>
                                <div className={"modal-header bg-pal"}>
                                    <h2 className={"modal-title"} id={"staticBackdropLabel"}>Import copy from sister campus</h2>
                                    <button type={"button"} className={"btn-close"} id={"copyClose"}
                                            data-bs-dismiss={"modal"} aria-label={"Close"}/>
                                </div>
                                <div className={"modal-body"}>
                                    <form id={"copyForm"}>
                                        <h4>This feature will copy and import all note templates from the selected campus and them to </h4>
                                        <div className={"form-floating mb-3"}>
                                            <select className={"form-select"} required={true} id={"copy-campus"}
                                                    defaultValue={""}
                                                    onChange={(e) => {
                                                        formCheck("copyForm", "copySubmit")
                                                    }}>
                                                <option value={null} disabled={true}></option>
                                                {campusCopyOptions}
                                            </select>
                                            <label htmlFor={"device"}>Campus</label>
                                        </div>
                                    </form>
                                </div>
                                <div className={"modal-footer"}>
                                    <button type={"button"} className={"btn btn-secondary"} id={"cancelCopyBtn"}
                                            data-bs-dismiss={"modal"}>Cancel
                                    </button>
                                    <Button type={"button"} class={"btn btn-primary d-none ms-3"} disabled={true}
                                            spinner={true} text={"Loading"} id={"loadCopySubmit"}/>
                                    <Button type={"button"} class={"btn btn-primary ms-3"} id={"copySubmit"}
                                            onClick={() => {
                                                copyPerformSubmit();
                                            }}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <BulkDeleteModal modalContent={"preformModalContent"} submitBtn={"bulkPreformDeleteSubmit"}
                                     cancelBtn={"bulkPreformCancelDelete"} loadBtn={"loakBulkPreformDeleteSubmit"}
                                     closeBtn={"bulkPreformConfirmClose"} modalName={"preform-delete"}
                                     deletePerform={() => preformDeletePerform("bulkPreformDeleteSubmit", "loakBulkPreformDeleteSubmit", "bulkPreformConfirmClose", 0, preformActiveData.length)}
                                     start={0} end={preformActiveData.length} header={"Delete Note Templates"} />
                    <BulkDeleteModal modalContent={"reasonModalContent"} submitBtn={"bulkReasonDeleteSubmit"}
                                     cancelBtn={"bulkReasonCancelDelete"} loadBtn={"loakBulkReasonDeleteSubmit"}
                                     closeBtn={"bulkReasonConfirmClose"} modalName={"reason-delete"}
                                     deletePerform={() => reasonDeletePerform("bulkReasonDeleteSubmit", "loakBulkReasonDeleteSubmit", "bulkReasonConfirmClose", 0, reasonData.length)}
                                     start={0} end={reasonData.length} header={"Delete Reasons"}/>
                    <input type={"hidden"} id={"uContent"}/>
                    <div className={"footer-spacer"}>
                    </div>
                </div>
                <Footer/>
                {/* Floating Help Button - Quarter Circle Corner Shape */}
                <button 
                    type={"button"} 
                    className={"help-corner-button"}
                    onClick={() => showModal("helpmodal")}
                    title={"Page Help Popup"}
                    aria-label={"Open Help"}
                >
                    <i className={"fe fe-help-circle help-corner-button-icon"}></i>
                </button>
                <Suspense fallback={"Loading..."}>
                    <ToastContainer position={"bottom-right"} theme={"colored"} newestOnTop={true} pauseOnHover={true}
                                    autoClose={10000} closeOnClick={true}/>
                </Suspense>
            </div>
            <div className={"modal fade help-modal-pop"} id={"helpmodal"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                 tabIndex={-1} aria-labelledby={"staticHelpBackdropLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog modal-lg"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title"} id={"staticHelpBackdropLabel"}>System Settings Page Help</h2>
                            <button type={"button"} className={"btn-close"} id={"helpClose"} data-bs-dismiss={"modal"}
                                    aria-label={"Close"}/>
                        </div>
                        <div className={"modal-body"}>
                            <div className={"mb-4"}>
                                <h4 className={"text-primary mb-3"}>
                                    <i className={"fe fe-info me-2"}></i>Getting Started
                                </h4>
                                <p className={"mb-2"}>
                                    The System Settings page allows you to configure various system-wide settings for your community. 
                                    Use the tabs at the top to navigate between different setting categories.
                                </p>
                            </div>
                            
                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-bell me-2 text-primary"}></i>Alert Behavior Settings
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        <strong>Max Alert Timeout:</strong> Maximum length of time alerts stay active in the system (60-360 minutes).
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Accept Alerts:</strong> Require users to accept alerts before responding.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Finish Alerts:</strong> Require users to mark when they are completed with an alert.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Record Reason:</strong> Require users to record a reason when finishing alerts.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Release Timeout:</strong> Time to automatically release an alert after acceptance with no device clear.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Clear Timeout:</strong> Time to automatically clear an alert after no contact from the system.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Finish Timeout:</strong> Time to automatically finish an alarm if stale after accept and clear.
                                    </li>
                                </ul>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-user me-2 text-primary"}></i>Customizations
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        These settings control what users can modify in their own profiles.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Display Name:</strong> Allow users to change their display name.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Group:</strong> Allow users to change the group of alerts they receive.
                                    </li>
                                </ul>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-alert-circle me-2 text-primary"}></i>High Priority Alerts
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        Select event types that should be treated as high priority alerts.
                                    </li>
                                    <li className={"mb-2"}>
                                        High priority alerts may have different notification behaviors.
                                    </li>
                                    <li className={"mb-2"}>
                                        Use the checkboxes to enable or disable high priority status for each event type.
                                    </li>
                                </ul>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-smartphone me-2 text-primary"}></i>Accept/Finish Devices
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        Configure which device types require accept/finish/reason workflows.
                                    </li>
                                    <li className={"mb-2"}>
                                        These devices will follow the alert behavior settings configured above.
                                    </li>
                                    <li className={"mb-2"}>
                                        Use the checkboxes to enable or disable AFR (Accept/Finish/Reason) for each device type.
                                    </li>
                                </ul>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-list me-2 text-primary"}></i>Custom Reasons
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        Create and manage custom reason codes for alert completion.
                                    </li>
                                    <li className={"mb-2"}>
                                        Click <strong>"Reason"</strong> to add a new custom reason code.
                                    </li>
                                    <li className={"mb-2"}>
                                        Each reason must have a name and be assigned to a reason category.
                                    </li>
                                    <li className={"mb-2"}>
                                        Click the edit icon to modify existing reasons, or select multiple and use "Delete" to remove them.
                                    </li>
                                </ul>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-file-text me-2 text-primary"}></i>Event Note Templates
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        Create preset note templates for event documentation.
                                    </li>
                                    <li className={"mb-2"}>
                                        Click <strong>"Note Template"</strong> to add a new template.
                                    </li>
                                    <li className={"mb-2"}>
                                        Templates can be used when documenting events to save time and ensure consistency.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Campus Import:</strong> (Admin only) Import note templates from other campuses.
                                    </li>
                                    <li className={"mb-2"}>
                                        Click the edit icon to modify templates, or select multiple and use "Delete" to remove them.
                                    </li>
                                </ul>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-server me-2 text-primary"}></i>Server Settings
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        <strong>System Offline Time:</strong> Time in minutes before the system is considered offline (10-60 minutes).
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Emergency Email Addresses:</strong> Email addresses to notify when the system goes offline. Press Enter or comma to add addresses.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Emergency Phone Numbers:</strong> Phone numbers to notify when the system goes offline. Numbers are formatted as (XXX) XXX-XXXX.
                                    </li>
                                    <li className={"mb-2"}>
                                        Click the X on any email or phone tag to remove it from the list.
                                    </li>
                                </ul>
                            </div>

                            <div className={"mb-3"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-settings me-2 text-primary"}></i>Additional Tips
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        Changes to settings are saved automatically when you click the "Save" button.
                                    </li>
                                    <li className={"mb-2"}>
                                        Use the "Cancel" button to discard unsaved changes and revert to the original values.
                                    </li>
                                    <li className={"mb-2"}>
                                        Save and Cancel buttons only appear when changes have been made.
                                    </li>
                                    <li className={"mb-2"}>
                                        Timeout values are set in minutes and must be within the specified ranges.
                                    </li>
                                    <li className={"mb-2"}>
                                        Some settings may require specific permissions or authority levels to modify.
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className={"modal-footer"}>
                            <button type={"button"} className={"btn btn-secondary"} data-bs-dismiss={"modal"}>Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SystemSettings;